import { render, staticRenderFns } from "./CardShengya.vue?vue&type=template&id=3c1a2979&scoped=true"
import script from "./CardShengya.vue?vue&type=script&lang=js"
export * from "./CardShengya.vue?vue&type=script&lang=js"
import style0 from "./CardShengya.vue?vue&type=style&index=0&id=3c1a2979&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a2979",
  null
  
)

export default component.exports